import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'lupa',
  templateUrl: 'lupa.html'
})
export class LupaComponent {

  @Input() open: boolean;
  public icona: String;
  public activat: boolean;
  @Output() LupaActive = new EventEmitter();

  constructor(public navCtrl: NavController) {
    
  }

  ngOnInit(){
    this.activat = this.open;
  }

  isActived(){
    this.activat = !this.activat;
    this.LupaActive.emit({
      value: this.activat
    });
  }

  tipusIcona(){
    return this.activat?"close":"search"; 
  }

}



// WEBPACK FOOTER //
// ./src/components/lupa/lupa.ts